import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  openModal: false,
}

const addContactsSlice = createSlice({
  name: 'addContacts',
  initialState,
  reducers: {
    openAddContactsModal(state, { payload }) {
      state.openModal = payload
    }
  }
})

export const {
  openAddContactsModal
} = addContactsSlice.actions;

export default addContactsSlice.reducer;